import React, { useEffect, useRef, useState } from 'react';
import './AdBanner.css';

const AdBanner = ({ slot }) => {
  const adRef = useRef(null);
  const pushed = useRef(false);
  // 'loading' stays invisible (but keeps its layout space) until we know
  // whether the slot actually filled, so reloads never flash a blank box.
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    if (adRef.current && !pushed.current) {
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
        pushed.current = true;
      } catch (e) {
        setStatus('unfilled');
      }
    }

    const el = adRef.current;
    if (!el) return;

    const checkStatus = () => {
      const adStatus = el.getAttribute('data-ad-status');
      if (adStatus === 'unfilled') setStatus('unfilled');
      else if (adStatus === 'filled') setStatus('filled');
    };

    const observer = new MutationObserver(checkStatus);
    observer.observe(el, { attributes: true, attributeFilter: ['data-ad-status'] });

    // Ad blockers or slow networks may never set data-ad-status at all.
    const fallback = setTimeout(() => {
      if (!el.getAttribute('data-ad-status')) setStatus('unfilled');
    }, 3000);

    return () => {
      observer.disconnect();
      clearTimeout(fallback);
    };
  }, []);

  if (status === 'unfilled') return null;

  return (
    <div
      className="ad-banner"
      data-slot={slot}
      style={status === 'loading' ? { visibility: 'hidden' } : undefined}
    >
      <ins
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client="ca-pub-4746911113417000"
        data-ad-slot="auto"
        data-ad-format="auto"
        data-full-width-responsive="true"
        ref={adRef}
      />
    </div>
  );
};

export default AdBanner;
